import type { MetricDashboardSource } from "@/metrics/catalog"
import {
  resolvedThresholdToTargetCondition,
  resolveSuccessValue,
  resolveThreshold,
} from "@/metrics/metric-display"

import {
  SET_COMPARISON_OPERATOR,
  type TargetCondition,
} from "@/types/metrics/contracts"

import { GROUP_BY_TYPE, type GroupByType } from "../../types/chart-types"
import type { DashboardChartRow } from "./chartQueryState"

export type { DashboardChartRow } from "./chartQueryState"

export function resolveChartTargetCondition(
  metric: MetricDashboardSource | null | undefined,
  metricIsBinary: boolean,
): TargetCondition | undefined {
  if (!metric) {
    return undefined
  }

  if (metricIsBinary) {
    return {
      target_values: [resolveSuccessValue(metric)],
      comparison_operator: SET_COMPARISON_OPERATOR.IN,
    }
  }

  const threshold = resolveThreshold(metric)
  if (!threshold) {
    return metric.metric_metadata?.target_condition
  }

  return (
    resolvedThresholdToTargetCondition(threshold) ??
    metric.metric_metadata?.target_condition
  )
}

interface GetChartAgentIdsParams {
  dimension: GroupByType | undefined
  flexibleRows: DashboardChartRow[] | null | undefined
  statisticRows: DashboardChartRow[]
}

export function getChartAgentIds({
  dimension,
  flexibleRows,
  statisticRows,
}: GetChartAgentIdsParams): string[] {
  if (
    dimension !== GROUP_BY_TYPE.AGENT &&
    dimension !== GROUP_BY_TYPE.MUTATION
  ) {
    return []
  }

  const agentIds = new Set<string>()
  const addAgentId = (agentId?: string | null) => {
    if (agentId) {
      agentIds.add(agentId)
    }
  }

  for (const row of [...(flexibleRows ?? []), ...statisticRows]) {
    addAgentId(row.run_agent_id)
    if (dimension === GROUP_BY_TYPE.MUTATION) {
      addAgentId(row.mutation_id)
    }
  }

  return Array.from(agentIds)
}
